export default "__VITE_ASSET__B46CrH24__"